import { FETCH_ORG_MODULES } from "../queries/org_modules";
import axios from "axios";

export const findOrgModules = async (graphql, orgId) => {
  try {
    const response = await axios({
      method: "post",
      url: graphql.url,
      data: {
        query: FETCH_ORG_MODULES,
        variables: { orgId },
      },
      headers: {
        Authorization: `Bearer ${graphql.token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
